module.exports = __webpack_public_path__ + "static/media/banner3.6948922a.png";